export default __webpack_public_path__ + "static/media/VK-Logo.ced771c2.svg";